import ProjectWorkspaceSettingsForm from '@/frontend/features/Fde/ProjectWorkspaceSettingsForm'
import type { ManagementProps } from '@/frontend/features/Fde/types'
import ProjectSlackChannel, { type ProjectSlackSnapshot } from '@/frontend/features/Fde/ProjectSlackChannel'
import ProjectIntegrations from '@/frontend/features/IntegrationAccess/ProjectIntegrations'
import ProjectPraxisBinding, { type ProjectPraxisSnapshot } from '@/frontend/features/Fde/ProjectPraxisBinding'

export default function ProjectSettings({ props }: { props: ManagementProps & { project_slack?: ProjectSlackSnapshot | null; project_praxis?: ProjectPraxisSnapshot | null } }) {
  if (!props.project) return null
  return <div className="h-full min-h-0 overflow-y-auto">
    <ProjectWorkspaceSettingsForm project={props.project} copy={props.copy} />
    {props.project_praxis && <ProjectPraxisBinding key={props.project.id} projectId={props.project.id} snapshot={props.project_praxis} />}
    {props.integration_access && <ProjectIntegrations snapshot={props.integration_access} />}
    {props.project_slack && <ProjectSlackChannel key={props.project.id} projectId={props.project.id} snapshot={props.project_slack} />}
  </div>
}
